import { render, staticRenderFns } from "./ParceiroListFiltroModalItem.vue?vue&type=template&id=1ccd137c"
import script from "./ParceiroListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./ParceiroListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports